import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['submitButton']
  
  connect() {
    this.addStartEventListener()
    this.addEndEventListener()
  }
  
  addStartEventListener() {
    this.element.addEventListener('direct-upload:start', (event) => {
      this.submitButtonTarget.setAttribute('disabled', true)
      this.submitButtonTarget.value = 'Uploading...'
    })
  }
  
  addEndEventListener() {
    this.element.addEventListener('direct-upload:end', (event) => {
      this.submitButtonTarget.value = this.submitButtonTarget.dataset.disableWith
    })
  }
}